function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#282828;}\n\t.st1{fill:#FFFFFF;}\n");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M31.3,0C14,0,0,14,0,31.3s14,31.3,31.3,31.3s31.3-14,31.3-31.3C62.6,14,48.6,0,31.3,0C31.3,0,31.3,0,31.3,0z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 31.3,
  cy: 31.3,
  r: 12.3
});

const SvgRecord = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Ebene_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 62.6 62.6",
  style: {
    enableBackground: "new 0 0 62.6 62.6"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRecord, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/record.40d38ea0.svg";
export { ForwardRef as ReactComponent };